import React from 'react'

import {type BlocksByColumns} from '../../../../api'
import {BlocksLayoutProvider} from './BlocksLayoutProvider'
import styleClasses from './classes@desktop.module.css'
import {InfoBlock} from './InfoBlock'

type Props = {
  blocks?: BlocksByColumns
}

export function BlocksLayout({blocks}: Props) {
  if (!blocks) {
    return null
  }

  return (
    <BlocksLayoutProvider value={{isMobile: false}}>
      <div className={styleClasses.blocksLayout}>
        <div className={styleClasses.blocksLayoutTop}>
          {blocks.top.map(block => (
            <InfoBlock key={block.id} block={block} />
          ))}
        </div>

        <div className={styleClasses.blocksLayoutColumns}>
          {blocks.columns.map((column, index) => (
            <div key={index} className={styleClasses.blockLayoutColumn}>
              {column.map(block => (
                <InfoBlock key={block.id} block={block} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </BlocksLayoutProvider>
  )
}
